/** 资源管理器分类（与工程目录 audio / graphics 等对应） */
export type ResourceCategoryKey = 'audio' | 'graphic' | 'font' | 'video'

export const RESOURCE_CATEGORIES: Array<{
  key: ResourceCategoryKey
  label: string
  folderName: string
}> = [
  { key: 'graphic', label: '图像', folderName: 'graphics' },
  { key: 'audio', label: '音频', folderName: 'audio' },
  { key: 'font', label: '字体', folderName: 'font' },
  { key: 'video', label: '视频', folderName: 'video' },
]

/** 当前资源管理器界面开放的分类；视频资源暂不支持编辑，保留底层结构但隐藏入口。 */
export const VISIBLE_RESOURCE_CATEGORIES = RESOURCE_CATEGORIES.filter((item) => item.key !== 'video')

/** dataTransfer 类型：资源管理器拖出的工程内相对路径（如 graphics/a.png） */
export const AVG_RESOURCE_PATH_MIME = 'application/x-avgmaker-resource-path'

/** dataTransfer 类型：资源管理器拖到 canvas 时附带的资源元信息。 */
export const AVG_CANVAS_RESOURCE_MIME = 'application/x-avgmaker-canvas-resource'

/** 虚拟资源：在资源管理器内移动 URL 资源（夹带 category /路径 / 子下标） */
export const VIRTUAL_FILE_MOVE_MIME = 'application/x-avgmaker-virtual-file-move'
